import { AbstractControl, FormControl, ValidationErrors } from "@angular/forms";
import moment from 'moment';

export function validateDateFormat(dateInputFormats) {
    // const moment = new Moment();
    return (control: AbstractControl): ValidationErrors | null => {
        return control.value && !moment?.parseZone(control.value, dateInputFormats, true).isValid() ?
            { dateFormat: 'research.form.field.error.date.format' } :
            null;
    }
}
